import { render, staticRenderFns } from "./cascader-widget.vue?vue&type=template&id=684f0e44&scoped=true"
import script from "./cascader-widget.vue?vue&type=script&lang=js"
export * from "./cascader-widget.vue?vue&type=script&lang=js"
import style0 from "./cascader-widget.vue?vue&type=style&index=0&id=684f0e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684f0e44",
  null
  
)

export default component.exports